import _styled from "styled-components";
import { PureComponent } from "react";
import PropTypes from "prop-types";
import FadeIn from "../Transitions/FadeIn/FadeIn";
import Box from "../../Styled/Box";
import Spacing from "../../Styled/Spacing";
import { TextSpan } from "../../Styled/Text";
import { RawButton } from "../../Styled/Button";
import { withTheme } from "styled-components";
import Caret from "../Generic/Caret";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Prompt extends PureComponent {
  // Tried to keep/make use of the original story prompt css properties
  render() {
    var _this$props$theme, _this$props$theme2;
    return /*#__PURE__*/_jsx(FadeIn, {
      isVisible: this.props.isVisible,
      children: /*#__PURE__*/_jsxs(_StyledBox, {
        displayInlineBlock: true,
        rounded: true,
        position: "absolute",
        backgroundColor: (_this$props$theme = this.props.theme) === null || _this$props$theme === void 0 ? void 0 : _this$props$theme.colorPrimary,
        paddedRatio: 3,
        styledWidth: "".concat(this.props.promptWidth || 200, "px"),
        $_css: this.props.promptTopOffset || 50,
        $_css2: this.props.promptLeftOffset || -140,
        children: [/*#__PURE__*/_jsx(Caret, {
          style: {
            top: "".concat(this.props.caretTopOffset || -8, "px"),
            left: "".concat(this.props.caretLeftOffset || 160, "px")
          },
          size: this.props.caretSize || 18,
          background: (_this$props$theme2 = this.props.theme) === null || _this$props$theme2 === void 0 ? void 0 : _this$props$theme2.colorPrimary
        }), this.props.content, /*#__PURE__*/_jsx(Spacing, {
          bottom: 3
        }), /*#__PURE__*/_jsx(Box, {
          fullWidth: true,
          centered: this.props.centered,
          children: /*#__PURE__*/_jsx(RawButton, {
            title: this.props.dismissText,
            onClick: this.props.dismissAction,
            children: /*#__PURE__*/_jsx(TextSpan, {
              isLink: true,
              medium: true,
              textLight: true,
              children: this.props.dismissText
            })
          })
        })]
      })
    });
  }
}
Prompt.propTypes = {
  content: PropTypes.object,
  dismissText: PropTypes.string,
  dismissAction: PropTypes.func,
  displayDelay: PropTypes.number,
  promptWidth: PropTypes.number,
  promptTopOffset: PropTypes.number,
  promptLeftOffset: PropTypes.number,
  caretTopOffset: PropTypes.number,
  caretLeftOffset: PropTypes.number,
  caretSize: PropTypes.number,
  centered: PropTypes.bool,
  isVisible: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired
};
export default withTheme(Prompt);
var _StyledBox = _styled(Box).withConfig({
  displayName: "Prompt___StyledBox",
  componentId: "sc-dqlvgo-0"
})(["top:", "px;left:", "px;pointer-events:auto;"], p => p.$_css, p => p.$_css2);